export default "__VITE_ASSET__CUPujlkV__"